import { Typography } from "@mui/material";
import React from "react";
import styles from "./formCategory.module.css";
import Grid from "@mui/material/Grid";
import TextField from "component/textField/TextField";
import RadioWithInput from "component/inputs/radioWithInput/RadioWithInput";
import ValidationMessage from "component/validationMessage/ValidationMessage";

function FindProperty({ formData, register, watch, errors }) {
  return (
    <div className={styles.category_tab}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={4}>
          <div className={styles.category}>
            <Typography variant="h6">
              Did you find a property amongst our listings?{" "}
              <span style={{ color: "red" }}>*</span>
            </Typography>
            <Typography>
              Please indicate if you found your desired property on the system
              or elsewhere.
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} sm={8}>
          <div className={styles.category_form}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <RadioWithInput
                    register={register}
                    name="foundProperty"
                    value={"true"}
                    label="yes"
                  />
                  {errors?.foundProperty && (
                    <ValidationMessage message= {errors?.foundProperty?.message} />
                    // <Typography style={{ marginTop: 8, color: "red" }}>
                    //   {errors?.foundProperty?.message}
                    // </Typography>
                  )}
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <RadioWithInput
                    register={register}
                    name="foundProperty"
                    value={"false"}
                    label="no"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default FindProperty;
